<form [formGroup]="SRPCreateFrom" (ngSubmit)="createRepairForm()" class="form-horizontal form-material"
  id="SRPCreateFrom" novalidate>
  <div class="modal-header">
    <h4 class="modal-title">Suggested Retail Markup Form</h4>
    <span class="btn btn-sm float-right" (click)="activeModal.close()">
      <i class="mdi mdi-close"></i>
    </span>
  </div>
  <div class="modal-body">
    <div class="form-group row">
      <div class="col-12">
        <h5>PRODUCER INFORMATION</h5>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-12 col-xl-6"><b>Agent / Representative: </b>{{agentName}}</div>
      <div class="col-12 col-xl-6"><b>Date: </b>{{dealData.createdAt | date: 'MM/dd/yyyy'}}</div>
      <div class="col-12 col-xl-6"><b>Producer Name: </b>{{dealData.name}}</div>
      <div class="col-12 col-xl-6"><b>Producer Group: </b> <span *ngIf="dealData.groupId && dealData.groupId.name">{{dealData.groupId.name}}  </span></div>
    </div>
    <div class="form-group row">
      <div class="col-12">
        <h5>Suggested Retail Markup</h5>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-12 col-xl-2">
        <app-required-indication [control]="SRPCreateFrom.controls['type']" [label]="'Type'">
        </app-required-indication>
      </label>
      <div class="col-12 col-xl-4 p-ls-xl-0">
        <app-form-error-wrapper [control]="SRPCreateFrom.get('type')" [controlName]="'type'" [apiErrorType]="'type'">
          <select class="custom-select form-control" name="type" formControlName="type">
            <option value="">Select Type</option>
            <option value="value">value($)</option>
            <option value="percentage">Percentage(%)</option>
          </select>
        </app-form-error-wrapper>
      </div>
      <label class="col-12 col-xl-2 text-xl-center">
        <app-required-indication [control]="SRPCreateFrom.controls['mode']" [label]="'Mode'">
        </app-required-indication>
      </label>
      <div class="col-12 col-xl-4 p-ls-xl-0">
        <app-form-error-wrapper [control]="SRPCreateFrom.get('mode')" [controlName]="'mode'" [apiErrorType]="'mode'">
          <select class="custom-select form-control" name="mode" formControlName="mode">
            <option value="">Select Mode</option>
            <option value="aboveCost">Above Cost</option>
            <option value="aboveZero">Above Zero</option>
          </select>
        </app-form-error-wrapper>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-12">
        <div class="smart-table incentive-table" formArrayName="productMinMax">
          <table class="w-100">
            <thead>
              <tr>
                <th>Products</th>
                <th>SRP</th>
                <th *ngIf="flNotSelected"></th>
                <th *ngIf="flNotSelected">Min</th>
                <th *ngIf="flNotSelected">Max</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of productMinMaxControls; let i = index">
                <ng-container *ngIf="item.get('name').value != 'GAP' || (dealData.state != 'FL' && item.get('name').value == 'GAP')">
                  <tr [formGroupName]="i">
                    <td>{{ item.get('name')?.value }}</td>
                    <!-- SRP Field -->
                    <td>
                      <app-form-error-wrapper [control]="item.get('srp')" [controlName]="'SRP'" [apiErrorType]="'srp'">
                        <input type="tel" class="form-control" [formControl]="item.get('srp')" currencyMask
                          [options]="currencyOptions" maxlength="9" maxlength="9" />
                      </app-form-error-wrapper>
                    </td>

                    <td *ngIf="flNotSelected">
                      <button type="button" *ngIf="dealData.state!='FL' && !item.get('enableMinMax').value" class="btn btn-sm btn-primary" (click)="item.get('enableMinMax').setValue(true);updateMinMaxValidators()">
                      Add Min-Max
                    </button>
                      <button type="button" *ngIf="dealData.state!='FL' && item.get('enableMinMax').value" class="btn btn-sm btn-danger" (click)="item.get('enableMinMax').setValue(false);updateMinMaxValidators()">
                      remove Min-Max
                    </button>
                    </td>
                    <!-- Min Field -->
                    <td *ngIf="flNotSelected">
                      <input *ngIf="item.get('enableMinMax').value" type="tel" class="form-control" [formControl]="item.get('min')" currencyMask
                        [options]="currencyOptions" maxlength="9" maxlength="9" /> 
                    </td>
                    <!-- Max Field -->
                    <td *ngIf="flNotSelected">
                      <input *ngIf="item.get('enableMinMax').value" type="tel" class="form-control" [formControl]="item.get('max')" currencyMask
                        [options]="currencyOptions" maxlength="9" maxlength="9" />
                    </td>
                  </tr>
                </ng-container>
                <tr *ngIf="item.errors?.aboveCostInvalid || item.errors?.aboveZeroInvalid || item.errors?.minMaxInvalid">
                  <td colspan="2"></td>
                  <td colspan="2">
                    <div *ngIf="item.errors?.aboveCostInvalid" class="text-danger">
                      Min/Max must be greater than SRP
                    </div>
                    <div *ngIf="item.errors?.aboveZeroInvalid" class="text-danger">
                      Min/Max must be greater than 0
                    </div>
                    <div *ngIf="item.errors?.minMaxInvalid" class="text-danger">
                      Min must be less than Max
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="activeModal.dismiss()">
      Cancel
    </button>
    <button class="btn btn-primary" [disabled]="SRPCreateFrom.invalid || isLoading">
      <app-button-loader [isLoading]="isLoading" [label]="'Add Suggested Retail Markup PDF'"
        (click)="checkValidfields()"></app-button-loader>
    </button>
  </div>
</form>